import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faLock, faReply, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


export interface RoadmapGoalPlanDialogData {
  roadmapId: number;
  targetConditionName: string;
  targetCategoryName: string;
  isLocked: boolean;
  targetConditionDescription: string;
  goalPlan: string;
}

@Component({
  selector: 'app-roadmap-goal-plan',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressBarModule,
    FontAwesomeModule,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './roadmap-goal-plan.component.html',
  styleUrl: './roadmap-goal-plan.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoadmapGoalPlanComponent {
  private readonly dialogRef = inject(MatDialogRef<RoadmapGoalPlanComponent>);
  protected readonly data: RoadmapGoalPlanDialogData = inject(MAT_DIALOG_DATA);
  protected readonly isLoading = signal(false);
  protected readonly showGoal = signal(false);

  faQuestionCircle = faQuestionCircle;
  faLock = faLock;
  faReply = faReply;
  faWindowClose = faWindowClose;

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.data.goalPlan);
  }
}
